import options from './get-focus.directive';

export default {
    selector: 'getFocus',
    options
};
